export const PAGE_SEO = {
  home: {
    title: "Just Dessert Me — Hamilton's Home of Rolled Ice Cream, Waffles & Desserts",
    description:
      "Hamilton's family dessert destination — fresh rolled ice cream, waffles, pancakes, milkshakes and famous Cookie Pies in Hillcrest. Dine in or order dessert delivery across Hamilton and NZ-wide.",
    path: "/",
  },
  shop: {
    title: "Cookie Pies Hamilton · Dessert Delivery Hamilton & NZ-wide | Just Dessert Me",
    description:
      "Order Cookie Pies and Loaded Cookies online for dessert delivery in Hamilton and NZ-wide. Mix-and-match 4, 8 or 12 packs with bulk discounts. Flat $8.90 shipping anywhere in New Zealand.",
    path: "/shop",
  },
  menus: {
    title: "Dessert Menu Hamilton — Rolled Ice Cream, Waffles, Pancakes & Milkshakes | Just Dessert Me",
    description:
      "Hamilton's freshest dessert menu — hand-rolled ice cream, fluffy waffles, pancakes Hamilton-made to order, milkshakes and Cookie Pies. Build your own or pick a crowd favourite at our Hillcrest dessert cafe.",
    path: "/menus",
  },
  events: {
    title: "Book Our Mobile Dessert Trailer for Your Event | Just Dessert Me Hamilton",
    description:
      "Our vintage caravan dessert trailer caters weddings, corporate events, birthdays, festivals and private parties across Hamilton and the Waikato. Handcrafted rolled ice cream made on site.",
    path: "/events",
  },
  dailySpecials: {
    title: "Daily Specials Hamilton — A New Dessert Deal Every Day | Just Dessert Me",
    description:
      "See our rotating daily specials at Just Dessert Me — Hamilton's home of rolled ice cream and waffles. New dessert deals every Tuesday through Sunday in Hillcrest, plus an everyday discount.",
    path: "/daily-specials",
  },
  faq: {
    title: "FAQ — Hamilton Dessert Shop, Cookie Pie Orders & Delivery | Just Dessert Me",
    description:
      "Frequently asked questions about ordering Cookie Pies online, NZ-wide shipping, dietary options, in-store visits and dessert delivery from Hamilton's home of rolled ice cream.",
    path: "/faq",
  },
  blog: {
    title: "Blog — Dessert News & Stories from Hamilton | Just Dessert Me",
    description:
      "Weekly stories from Hamilton's home of rolled ice cream — new dessert flavours, behind-the-scenes peeks, Cookie Pie tips and what's happening at our Hillcrest dessert cafe.",
    path: "/blog",
  },
  about: {
    title: "About — Hamilton's Family Dessert Destination | Just Dessert Me",
    description:
      "Hamilton's family dessert destination — a Hillcrest dessert cafe perfecting fresh-made rolled ice cream, waffles, pancakes and famous Cookie Pies. Watch it freeze, taste the magic.",
    path: "/about",
  },
  contact: {
    title: "Contact Our Dessert Cafe — 113 Cambridge Road, Hillcrest Hamilton | Just Dessert Me",
    description:
      "Find Just Dessert Me — Hamilton's best desserts at 113 Cambridge Road, Hillcrest. Phone 07 823 2391, or message us for orders, custom cakes and Hamilton dessert delivery enquiries.",
    path: "/contact",
  },
  success: {
    title: "Order Confirmed | Just Dessert Me",
    description: "Thanks for your order — we'll have it ready shortly.",
    path: "/success",
  },
  cancel: {
    title: "Checkout Cancelled | Just Dessert Me",
    description: "Your cart is still ready whenever you'd like to continue.",
    path: "/cancel",
  },
};
